import { forwardRef } from 'react'
import { Body, Box, Button, H3 } from '../widgets'
import { Form, Submit } from '../forms'
import './InputScreen.scss'

export const InputScreen = forwardRef(function InputScreen({ centered, onSubmit, fade, fadeColour = 'black', fullWidth,
                formValues, title, description, footerButton, altFooterButton, altOnClick, children, ...props }, ref) {
  return (
    <Box className={`input-screen${centered ? ' centered' : ''}`}>
      <Form
        onSubmit={onSubmit}
        style={{ background: fade ? `var(--${fadeColour}-fade)` : undefined, width: fullWidth ? '100%' : '' }}
        values={formValues}
      >
        <Box
          className={`container${(footerButton || altFooterButton) ? ' container-footer-button' : ''}${(footerButton && altFooterButton) ? '-double' : ''}`}
          fullWidth
          column
          grow
        >
          <Box className={`scroll-area${(footerButton || altFooterButton) ? ' scroll-area-footer-button' : ''}`}>
            <Box className="content" pb={(footerButton || altFooterButton) ? 0 : 32} {...props} >
              {(title || description) && <Box className="form-title">
                {title && <H3 align="center">{title}</H3>}
                {description && <Body align="center" lineHeight="177%">
                  {description}
                </Body>}
              </Box>}
              {children}
            </Box>
          </Box>
        </Box>

        {(footerButton || altFooterButton) &&
          <Box className="footer-button" ref={ref}>
            {altFooterButton && <Button light fullWidth onClick={altOnClick}>{altFooterButton}</Button>}
            {footerButton && <Submit fullWidth>{footerButton}</Submit>}
          </Box>
        }
      </Form>
    </Box>
  )
})
